import MasterTasks from './masterTasksContainer';

export default MasterTasks;
